import { IconProps, SvgIcon } from "@mui/material";

const WebIcon = ({ sx }: IconProps) => {
  return (
    <SvgIcon sx={sx}>
      <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.0952 12.4286H15.1284C14.6649 12.4286 14.2205 12.6434 13.8927 13.0257C13.565 13.4081 13.3809 13.9266 13.3809 14.4673V19.0953"
          stroke="#0D579B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.7619 2.90479V4.36525C5.7619 5.06526 6.05931 5.7366 6.5887 6.23158C7.11809 6.72656 7.8361 7.00464 8.58477 7.00464C9.08388 7.00464 9.56255 7.19003 9.91548 7.52002C10.2684 7.85 10.4667 8.29756 10.4667 8.76424C10.4667 9.73201 11.3135 10.5238 12.3486 10.5238C12.8477 10.5238 13.3264 10.3384 13.6793 10.0085C14.0322 9.67847 14.2305 9.23091 14.2305 8.76424C14.2305 7.79646 15.0774 7.00464 16.1124 7.00464H19.0952"
          stroke="#0D579B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.5238 19.0952V15.3161C10.5238 14.8086 10.322 14.3219 9.96281 13.9631C9.6036 13.6043 9.11641 13.4027 8.60842 13.4027C8.10042 13.4027 7.61323 13.2011 7.25402 12.8422C6.89482 12.4834 6.69301 11.9967 6.69301 11.4892V10.5325C6.69301 10.025 6.49121 9.5383 6.13201 9.17946C5.7728 8.82061 5.28561 8.61902 4.77761 8.61902H1.95239"
          stroke="#0D579B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.5238 20.0476C15.7837 20.0476 20.0476 15.7837 20.0476 10.5238C20.0476 5.26395 15.7837 1 10.5238 1C5.26395 1 1 5.26395 1 10.5238C1 15.7837 5.26395 20.0476 10.5238 20.0476Z"
          stroke="#0D579B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default WebIcon;
